import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatInput } from './chat-input';
import { Card } from '@/components/shadcn-ui/card';
import { ProjectSelector } from './ProjectSelector';
import { useProjectStore } from '@/stores/useProject.store';
import { toast } from 'sonner';

export function NewChat() {
    const navigate = useNavigate();
    const [isCreatingChat, setIsCreatingChat] = useState(false);

    const handleFirstMessage = async (content) => {
        if (!content?.content?.trim() && (!content.attachments || content.attachments.length === 0)) return;

        if (isCreatingChat) return;

        setIsCreatingChat(true);

        try {
            const { createChat } = useProjectStore.getState();
            const newChat = await createChat();

            if (!newChat?.permitChat?._id) {
                throw new Error('Failed to create chat');
            }
            navigate(`/citypermit/project/chat/${newChat.permitChat._id}`, {
                state: { initialMessage: content },
                replace: true
            });
        } catch (error) {
            console.error('Error creating chat:', error);
            toast.error('Failed to create chat. Please try again.');
            setIsCreatingChat(false);
        }
    };

    return (
        <Card className="flex flex-col dark bg-background-secondary rounded-xl w-full h-full font-baloo-2">
            <div className="max-w-2xl mx-auto flex flex-col items-center shrink-0">
                <div className="mb-6">
                    <img src="/kelly.png" alt="Kelly Avatar" className="w-32 h-32 sm:w-40 sm:h-40 object-cover" />
                </div>
                <h2 className="text-xl sm:text-2xl font-medium text-white">Hey, I'm Kelly!</h2>
                <p className="text-base sm:text-lg text-gray-300">What type of project would you like to submit today?</p>
            </div>
            <div className="py-4">
                <ProjectSelector
                    onSelect={(option) => handleFirstMessage({ content: option, attachments: [] })}
                />
            </div>
            <div className="pt-3 mt-2 shrink-0">
                <ChatInput
                    onSendMessage={handleFirstMessage}
                    disabled={isCreatingChat}
                    showActions={false}
                />
            </div>
            <div className="text-center text-sm text-white font-thin mt-10">
                By messaging Zermit AI, you agree to our{' '}
                <span className="underline cursor-pointer" onClick={() => navigate('/terms')}>Terms</span> and have read our{' '}
                <span className="underline cursor-pointer" onClick={() => navigate('/terms')}>Privacy Policy.</span>
            </div>
        </Card>
    );
}
